import { Injectable } from "@angular/core";
import { IMilestone } from "@common/interfaces/milestone";
import { ID, QueryEntity } from "@datorama/akita";
import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";
import { MilestoneState, MilestoneStore } from "./milestone.store";

@Injectable({
  providedIn: 'root'
})
export class MilestoneQuery extends QueryEntity<MilestoneState> {
  active$ = this.selectActive<IMilestone>()
  all$ = this.selectAll();

  constructor(protected store: MilestoneStore) {
    super(store);
  }

  getByMilestoneIds(ids: ID[]) {
    return this.getAll({
      filterBy: milestone => ids.includes(milestone.id)
    })
  }

  selectMilestonesByProjectId(projectId: ID): Observable<IMilestone[]> {
    return this.selectAll({
      filterBy: entity => entity.projectId === projectId
    })
  }

  selectMilestonesByProjectIdNotTrashed(projectId: ID): Observable<IMilestone[]> {
    return this.selectAll({
      filterBy: milestone => milestone.projectId === projectId && !milestone.trashedAt
    })
  }

  milestoneByProjectAndStatus$(projectId: string, stateId: string): Observable<IMilestone[]> {
    return this.selectAll({
      filterBy: [
        issue => issue.projectId === projectId,
        issue => issue.stateId === stateId,
        issue => !issue.trashedAt
      ]
    }).pipe(shareReplay({ refCount: true, bufferSize: 1 }))
  }

  findMilestoneByLabel(label: string): IMilestone {
    const milestone = this.getAll({
      filterBy: entity => entity.label === label
    });
    if (milestone) {
      return milestone[0];
    }
    return null;
  }

  selectMilestoneByLabel(label: string): Observable<IMilestone> {
    return this.selectAll({
      filterBy: milestone => milestone.label === label
    }).pipe(map(milestones => milestones[0]))
  }

  selectMilestonesByMilestoneIds(milestoneIds: string[]): Observable<IMilestone[]> {
    return this.selectMany(milestoneIds);
  }

}
